var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVendorPhoneOtp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 237.811,
    height: 476.933,
    viewBox: "0 0 237.811 476.933",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3505"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12613",
    d: "M859.918 303.27H857.3v-71.787a41.549 41.549 0 0 0-41.549-41.549H663.656a41.549 41.549 0 0 0-41.549 41.549v393.835a41.549 41.549 0 0 0 41.549 41.549h152.092a41.549 41.549 0 0 0 41.552-41.549V354.371h2.621z",
    transform: "translate(-622.107 -189.933)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12614",
    d: "M849.907 233.139V626.4a31.022 31.022 0 0 1-31.033 31.022H666.049a31.02 31.02 0 0 1-31.022-31.022V233.139a31.02 31.02 0 0 1 31.024-31.022H684.6a14.748 14.748 0 0 0 13.652 20.3h87.13a14.733 14.733 0 0 0 13.652-20.3h19.845a31.022 31.022 0 0 1 31.028 31.022z",
    transform: "translate(-623.561 -191.305)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12615",
    d: "M805.431 464.543H671.1a8.884 8.884 0 0 1-8.874-8.874v-4.417a8.884 8.884 0 0 1 8.874-8.874h134.331a8.884 8.884 0 0 1 8.874 8.874v4.417a8.884 8.884 0 0 1-8.874 8.874z",
    transform: "translate(-626.623 -218.349)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12616",
    d: "M805.431 507.45H671.1a8.884 8.884 0 0 1-8.874-8.874v-4.417a8.884 8.884 0 0 1 8.874-8.874h134.331a8.884 8.884 0 0 1 8.874 8.874v4.417a8.884 8.884 0 0 1-8.874 8.874z",
    transform: "translate(-626.623 -223.179)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12617",
    d: "M812.946 454.835H678.618a9.329 9.329 0 0 1-9.318-9.318V441.1a9.329 9.329 0 0 1 9.318-9.318h134.329a9.329 9.329 0 0 1 9.318 9.318v4.417a9.329 9.329 0 0 1-9.319 9.318zm-134.329-21.279a7.552 7.552 0 0 0-7.543 7.543v4.417a7.552 7.552 0 0 0 7.543 7.543h134.329a7.552 7.552 0 0 0 7.543-7.543V441.1a7.552 7.552 0 0 0-7.543-7.543z",
    transform: "translate(-627.419 -217.156)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12618",
    d: "M812.946 497.742H678.618a9.329 9.329 0 0 1-9.318-9.318v-4.417a9.329 9.329 0 0 1 9.318-9.318h134.329a9.329 9.329 0 0 1 9.318 9.318v4.417a9.329 9.329 0 0 1-9.319 9.318zm-134.328-21.278a7.552 7.552 0 0 0-7.543 7.543v4.417a7.552 7.552 0 0 0 7.543 7.543h134.329a7.552 7.552 0 0 0 7.543-7.543v-4.417a7.552 7.552 0 0 0-7.543-7.543z",
    transform: "translate(-627.419 -221.986)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12619",
    d: "M862.543 233.139v85.54a91.884 91.884 0 0 1-115.263-88.81q0-3.763.3-7.448h50.43a14.733 14.733 0 0 0 13.652-20.3h19.845a31.022 31.022 0 0 1 31.036 31.018z",
    transform: "translate(-636.197 -191.305)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12620",
    d: "M712.246 700.489c0 1.8-.067 3.584-.213 5.342h-45.984a31.02 31.02 0 0 1-31.022-31.024v-42.062a68.4 68.4 0 0 1 77.219 67.744z",
    transform: "translate(-623.561 -239.713)",
    style: {
      fill: "#86c232"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12633",
    d: "M771.472 559.191H707.7a8.884 8.884 0 0 1-8.874-8.874V545.9a8.884 8.884 0 0 1 8.874-8.874h63.773a8.884 8.884 0 0 1 8.874 8.874v4.417a8.884 8.884 0 0 1-8.875 8.874z",
    transform: "translate(-630.743 -229.003)",
    style: {
      fill: "#86c232"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12634",
    d: "M778.988 549.483h-63.773a9.329 9.329 0 0 1-9.318-9.318v-4.417a9.329 9.329 0 0 1 9.318-9.318h63.773a9.329 9.329 0 0 1 9.318 9.318v4.417a9.329 9.329 0 0 1-9.318 9.318zM715.215 528.2a7.552 7.552 0 0 0-7.543 7.543v4.417a7.552 7.552 0 0 0 7.543 7.543h63.773a7.552 7.552 0 0 0 7.543-7.543v-4.417a7.552 7.552 0 0 0-7.543-7.543z",
    transform: "translate(-631.539 -227.81)",
    style: {
      fill: "#3f3d56"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorPhoneOtp);
export default __webpack_public_path__ + "static/media/VendorPhoneOTP.22800aa8ba98946ee1e096e0f618d2c9.svg";
export { ForwardRef as ReactComponent };